var map = {
	"./animal.png": 945,
	"./community.png": 946,
	"./family.png": 947,
	"./food.png": 948,
	"./green.png": 949,
	"./health.png": 950,
	"./help.png": 951,
	"./icon/audio.png": 616,
	"./icon/document.png": 617,
	"./icon/download.png": 618,
	"./icon/file.png": 619,
	"./icon/img_cartoon.png": 620,
	"./icon/img_line_graph.png": 621,
	"./icon/img_real.png": 622,
	"./icon/jttw360.png": 623,
	"./icon/learn.png": 624,
	"./icon/news.png": 625,
	"./icon/science.png": 626,
	"./icon/song_english.png": 627,
	"./icon/song_zh.png": 628,
	"./icon/storybook_video.png": 629,
	"./icon/teach_guide.png": 630,
	"./icon/treehouse.png": 631,
	"./icon/video.png": 632,
	"./mc/A.png": 633,
	"./mc/B.png": 634,
	"./mc/C.png": 635,
	"./mc/D.png": 636,
	"./mc/audio.png": 492,
	"./mc/audio_img/confirm_cn.png": 493,
	"./mc/audio_img/confirm_english.png": 494,
	"./mc/audio_img/confirm_zh.png": 495,
	"./mc/audio_img/question_cn.png": 496,
	"./mc/audio_img/question_english.png": 497,
	"./mc/audio_img/question_zh.png": 498,
	"./mc/bg.png": 499,
	"./mc/close.svg": 683,
	"./mc/cn.png": 637,
	"./mc/en.png": 638,
	"./mc/idea.png": 500,
	"./mc/rainbow.png": 501,
	"./mc/son.png": 502,
	"./mc/tick.webp": 994,
	"./mc/video_img/answer_cn.png": 503,
	"./mc/video_img/answer_english.png": 504,
	"./mc/video_img/answer_zh.png": 505,
	"./mc/video_img/question_cn.png": 506,
	"./mc/video_img/question_english.png": 507,
	"./mc/video_img/question_zh.png": 508,
	"./mc/wrong.webp": 995,
	"./mc/zh.png": 639,
	"./mc/zh_cn.png": 640,
	"./mc/zh_tw.png": 641,
	"./nature.png": 952,
	"./school.png": 953,
	"./transport.png": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2510;